var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowedHoldings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5492,
    cy: 41.5158,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.476,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.956,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.569,
    cy: 98.318,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.008 99.8076 167.008C62.6536 167.008 32.5493 137.155 32.5493 100.347C32.5493 63.5387 62.6536 33.6851 99.8076 33.6851C136.962 33.6851 167.066 63.5387 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.11465,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6664,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.794,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.76,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3154,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7998,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.3156,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.9333,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4995,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.0481,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4228,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8095,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.937,
    cy: 18.8427,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01196 117.65C7.06645 117.65 7.92129 116.795 7.92129 115.741C7.92129 114.686 7.06645 113.832 6.01196 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0315 22.4226C75.086 22.4226 75.9408 21.5678 75.9408 20.5133C75.9408 19.4588 75.086 18.604 74.0315 18.604",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 15.7399C119.278 15.7399 118.423 16.5948 118.423 17.6493C118.423 18.7038 119.278 19.5586 120.333 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.209 30.0596L172.242 30.0596M162.099 45.8115L162.218 39.6062M150.524 30.0596L148.972 30.0596M162.099 20.7516L162.099 8.57973M166.634 30.0596C163.65 30.0596 162.099 34.3556 162.099 34.3556C162.099 34.3556 161.622 30.0596 157.803 30.0596C159.521 30.0596 161.98 28.5083 162.218 25.4056C162.218 25.4056 162.496 27.9458 163.412 28.8663C164.176 29.6348 166.634 30.0596 166.634 30.0596Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 71.1826,
    width: 96,
    height: 64.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 71.1826,
    width: 96,
    height: 36.1111,
    rx: 9,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6667 67.0715V62.1826C83.6667 58.8689 86.353 56.1826 89.6667 56.1826H111.111C114.425 56.1826 117.111 58.8689 117.111 62.1826V66.4776",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1113 67.0714V64.627C89.1113 62.9701 90.4545 61.627 92.1113 61.627H108.667C110.324 61.627 111.667 62.9701 111.667 64.627V66.7744",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5554,
    y: 98.4048,
    width: 12.7778,
    height: 17.4444,
    rx: 6.38889,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.908 101C146.763 101 132.608 105.289 130.892 107.005C129.176 108.721 130.463 126.479 130.463 130.597C130.463 134.715 132.751 138.89 133.895 140.462C137.326 143.608 144.189 149.899 146.334 151.615C148.479 153.331 151.052 152.902 152.339 151.615C153.626 150.328 159.422 146.876 162.634 142.607C166.06 138.054 168.353 132.17 168.639 129.31C168.925 126.45 169.068 108.721 167.781 107.005C166.494 105.289 151.052 101 148.908 101Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.986 129.672C159.837 124.096 157.362 123.22 157.254 119.188C157.233 118.43 156.64 117.812 155.882 117.812H155.875V115.75C155.875 114.991 155.259 114.375 154.5 114.375H151.062C150.303 114.375 149.688 114.991 149.688 115.75V117.812H148.312V115.75C148.312 114.991 147.697 114.375 146.938 114.375H143.5C142.741 114.375 142.125 114.991 142.125 115.75V117.812H142.118C141.36 117.812 140.767 118.43 140.746 119.188C140.638 123.22 138.163 124.096 138.014 129.672L138 131.562C138 132.702 138.923 133.625 140.062 133.625H145.562C146.702 133.625 147.625 132.702 147.625 131.562V125.375H150.375V131.562C150.375 132.702 151.298 133.625 152.438 133.625H157.938C159.077 133.625 160 132.702 160 131.562L159.986 129.672ZM151.75 116.438H153.812V117.812H151.75V116.438ZM144.188 116.438H146.25V117.812H144.188V116.438ZM145.562 131.562L140.062 131.578L140.076 129.727C140.145 127.138 140.766 125.797 141.425 124.376C141.985 123.165 142.614 121.809 142.774 119.875H145.562V131.562ZM147.625 123.312V119.875H150.375V123.312H147.625ZM152.438 131.562V119.875H155.226C155.386 121.809 156.015 123.166 156.575 124.376C157.234 125.797 157.855 127.138 157.923 129.687L157.938 131.562H152.438Z",
    fill: "#194590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowedHoldings);
export default __webpack_public_path__ + "static/media/followed-holdings.b27e933fe1f7b6d5aa2c461e0350f5f6.svg";
export { ForwardRef as ReactComponent };